import { useApolloClient, useMutation } from '@apollo/client'
import { useCallback } from 'react'
import {
  AddCommentLikeDocument,
  CommentLikeFragmentDoc,
  RemoveCommentLikeDocument,
} from '~/__generated__/graphql'
import * as GA from '~/libs/ga'

export const useCommentLike = (videoId: string, commentId: string) => {
  const client = useApolloClient()
  const data = client.cache.readFragment({
    id: `Comment:${commentId}`,
    fragment: CommentLikeFragmentDoc,
  })

  const [addCommentLike] = useMutation(AddCommentLikeDocument, { variables: { commentId } })
  const [removeCommentLike] = useMutation(RemoveCommentLikeDocument, { variables: { commentId } })

  const onClickLike = useCallback(() => {
    if (data?.currentUserHasLike == true) {
      // delete like
      removeCommentLike({
        update: (cache) => {
          if (!!data) {
            cache.writeFragment({
              id: `Comment:${commentId}`,
              fragment: CommentLikeFragmentDoc,
              data: {
                currentUserHasLike: false,
                likeNum: (data.likeNum ?? 1) - 1,
              },
            })
          }
        },
      })
    } else {
      // add like
      GA.sendEvent({
        event: 'review_like',
        screen: 'movie_page',
        category: 'icon',
        action: 'movie_page_review_like',
        label: `${videoId}`,
        value: `${commentId}`,
      })
      addCommentLike({
        update: (cache) => {
          if (!!data) {
            cache.writeFragment({
              id: `Comment:${commentId}`,
              fragment: CommentLikeFragmentDoc,
              data: {
                currentUserHasLike: true,
                likeNum: (data.likeNum ?? 0) + 1,
              },
            })
          }
        },
      })
    }
  }, [data, videoId, commentId, addCommentLike, removeCommentLike])

  return {
    data,
    onClickLike,
  }
}
